/** @jsx jsx */
import { sanityImage } from 'lib/sanity/sanity'
import NextImage from 'next/image'
import { useState, useEffect, useRef } from 'react'
import { jsx, Box } from 'theme-ui'
// import { useBreakpointIndex } from '@theme-ui/match-media'

const EventMultiImage = ({ imageAsset }) => {
  const [opacity, setOpacity] = useState(1)
  const imageContainerRef = useRef()

  const image = useRef()

  useEffect(() => {
    if (image.current.complete) setOpacity(0)
  }, [image])

  const imageUrl = sanityImage(imageAsset)
    .quality(80)
    .width(960)
    .height(720)
    .url()

  return (
    <Box
      sx={{
        display: 'block',
        width: '100%',
        minWidth: '100%',
        lineHeight: '0px',
        fontSize: '0px',
        position: 'relative',
      }}
      ref={imageContainerRef}
    >
      {/* Image */}
      <Box
        sx={{
          position: 'relative',
          pt: '75%',
          // backgroundColor: imageAsset.colorImage ? '#ffffff' : 'red',
          display: ['block'],
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            height: 'calc(100% + 5px)',
            width: '100%',
            top: 0,
            left: 0,
            backgroundColor: 'black',
            opacity: opacity,
            transition: 'opacity 1000ms',
            zIndex: 99,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'block',
            width: '100%',
            minWidth: '100%',
            lineHeight: '0px',
            fontSize: '0px',
            backgroundColor: imageAsset.colorImage ? '#ffffff' : 'red',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'url(/noise.png)',
              backgroundPosition: 'center center',
              mixBlendMode: 'multiply',
              opacity: 0.6,
            }}
          />
          <Box
            sx={{
              position: 'relative',
              top: 0,
              left: 0,
              width: '100%',
              mixBlendMode: 'multiply',
              filter: 'brightness(1.12) contrast(1.05)',
            }}
          >
            <img
              ref={image}
              src={imageUrl}
              alt={imageAsset.alt ? imageAsset.alt : 'Artist image'}
              onLoad={e => {
                setOpacity(0)
              }}
              sx={{
                width: '100%',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { EventMultiImage }
